import { ClientShortHandName, getClientId } from '@snoam/mono-scc';
import { IIdentityOptions } from '@schibsted/account-sdk-browser';
import { getSchibstedEnvName } from '../fastflowUtils';

function spidOptions(
  clientShortHandName: ClientShortHandName | '',
  isProduction: boolean,
  location: Pick<Location, 'hostname'> = window.location,
): IIdentityOptions {
  const redirectUri = `https://${
    isProduction ? '' : 'test-'
  }redirect.s-plat.no`;
  const domains: { [k: string]: string } = {
    AP: 'aftenposten.no',
    ASK: 'av-avis.no',
    BTI: 'bt.no',
    BYN: 'bygdanytt.no',
    DNB: 'aftenposten.no',
    DP: 'e24dinepenger.no',
    MPL: 'magasinpluss.no',
    SA: 'aftenbladet.no',
    SCH: 'schibsted.no',
    STR: 'strilen.no',
    VG: 'vg.no',
    VNY: 'vestnytt.no',
  };
  const domain = domains[clientShortHandName];
  const isLocal = process.env.NODE_ENV === 'development';

  const sessionDomain =
    domain &&
    `https://id${isProduction ? '' : '-pre'}.${domains[clientShortHandName]}`;
  return {
    clientId: getClientId(clientShortHandName, isProduction),
    env: getSchibstedEnvName(location),
    redirectUri,
    sessionDomain,
    siteSpecificLogout: !isLocal,
  };
}

export default spidOptions;
